import { groq } from '@nuxtjs/sanity';

export default function getNavigationQuery(locale) {
  return groq`*[
    _type=="menu" &&
    __i18n_lang=="${locale}"
  ]`;
}
